module.exports = __webpack_public_path__ + "media/honey-icons/icon-cuttlery-drawer-fab29c0f.svg";